import React from 'react';
import { Link } from 'react-router-dom';

const Courses = () => {
  const courseCategories = [
    {
      category: 'Certificate Programs',
      programs: [
        { name: 'Certificate in Food Handlers',  description: 'A professional training program that provides essential knowledge of food safety and hygiene practices for safe food handling and preparation.', image: '/food-handler.jpg' },
        { name: 'Certificate in CPR and First aid',  description: 'A practical training program that provides essential life-saving skills to respond confidently and effectively in emergency situations.', image: '/first-aid.jpg' },
        { name: 'Certificate in Food service worker',  description: 'Training program that develops essential food service, hygiene, and customer care skills.', image: '/food.jpg' },
      ]
    }
  ];

  return (
    <div>
      <section className="hero" style={{ padding: '3rem 0' }}>
        <div className="container">
          <h2>Our Courses</h2>
          <p>Choose from a Wide Range of Programs</p>
        </div>
      </section>

      {courseCategories.map((category, index) => (
        <section 
          key={index} 
          className={index % 2 === 0 ? 'courses' : 'courses'} 
          style={index % 2 === 0 ? { background: 'var(--light-bg)' } : {}}
        >
          <div className="container">
            <h2 className="section-title">{category.category}</h2>
            <div className="courses-grid">
              {category.programs.map((program, pIndex) => (
                <div key={pIndex} className="course-card">
                  <div className="course-image">
                    <img src={program.image} alt={program.name} style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                  </div>
                  <div className="course-content">
                    <h3>{program.name}</h3>
                    <p>{program.description}</p>
                    <p>*Please note that these programs are non-vocational and do not require approval under the Ontario Career Colleges Act, 2005</p>
                    <Link to="/admissions" className="btn btn-primary">Apply Now</Link>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>
      ))}

      <section className="about">
        <div className="container" style={{ textAlign: 'center' }}>
          <h2 className="section-title">Ready to Start Your Journey?</h2>
          <p style={{ maxWidth: '600px', margin: '0 auto 2rem' }}>
            Join thousands of students who have chosen Fast Track College of Business, Healthcare and Technology for their education. 
            Apply now and take the first step towards a successful career.
          </p>
          <Link to="/admissions" className="btn btn-primary" style={{ marginRight: '1rem' }}>Apply for Admission</Link>
          <Link to="/contact" className="btn btn-secondary">Contact Us</Link>
        </div>
      </section>
    </div>
  );
};

export default Courses;
